import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LogIn } from "lucide-react";
import API_BASE_URL from "../config/Config.js";
import GlassCard from "./ui/GlassCard";
import Button from "./ui/Button";

export default function LoginForm() {
  const [data, setData] = useState({
    identifier: "", // email или username
    password: "",
  });

  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!data.identifier || !data.password) {
      setError("Пожалуйста, заполните все поля");
      return;
    }

    const identifier = data.identifier.trim();
    const isEmail = identifier.includes("@");
    const isIin = /^\d{12}$/.test(identifier);

    const payload = {
      email: isEmail ? identifier : "",
      iin: isIin ? identifier : "",
      username: !isEmail && !isIin ? identifier : "",
      password: data.password,
    };

    try {
      const res = await axios.post(`${API_BASE_URL}/auth/signin`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      localStorage.setItem("token", res.data.data.access_token);
      navigate("/");
    } catch (err) {
      console.error("Ошибка входа:", err);
      setError("Ошибка на сервере. Проверьте данные или повторите позже.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 pt-24 bg-gradient-to-br from-primary-50 via-white to-teal-50">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <GlassCard hover={false} className="p-8 bg-white/90">
          <div className="flex flex-col items-center mb-6">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-primary-500 to-teal-500 flex items-center justify-center shadow-glow mb-3">
              <LogIn className="w-7 h-7 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-dark-900">Вход</h2>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block mb-1 text-sm font-medium text-dark-700">
                Email, имя пользователя или ИИН
              </label>
              <input
                type="text"
                name="identifier"
                value={data.identifier}
                onChange={handleChange}
                required
                className="w-full rounded-lg border border-dark-200 px-3 py-2.5 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-dark-700">Пароль</label>
              <input
                type="password"
                name="password"
                value={data.password}
                onChange={handleChange}
                required
                className="w-full rounded-lg border border-dark-200 px-3 py-2.5 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
              />
            </div>

            {error && (
              <p className="text-red-600 text-sm bg-red-50 rounded-lg px-3 py-2">{error}</p>
            )}

            <Button type="submit" variant="primary" className="w-full justify-center">
              Войти
            </Button>

            <div className="text-center pt-2">
              <span className="text-sm text-dark-500">Нет аккаунта? </span>
              <Link to="/signup" className="text-primary-600 font-semibold hover:underline">
                Зарегистрироваться
              </Link>
            </div>
          </form>
        </GlassCard>
      </motion.div>
    </div>
  );
}
